import { Box, Typography } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import crossMarkIcon from "../assets/images/Vector (3).svg";
import greenTick from "../assets/images/material-symbols_check-circle-rounded.svg";
import { sponsorsModalList } from "../constants/CreateProfileLists";
import flightIcon from "../assets/images/flight-icon-with-bg.png";

const YearlyEssentialModal = ({ open, onClose, packToShow }) => {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
            padding: "20px",
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.3 } }}
          onClick={onClose}
          className="popup-content-container"
        >
          <motion.div
            style={{
              backgroundColor: "#fff",
              width: "100%",
              maxWidth: "640px",
              borderRadius: "20px",
              overflow: "hidden",
            }}
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", damping: 25 }}
            onClick={(e) => e.stopPropagation()}
            className="popup-content"
          >
            <Box>
              <Box
                sx={{
                  position: "relative",
                  paddingBottom: packToShow?.introductoryOffer?.isActive
                    ? "50px !important"
                    : "10px !important",
                }}
                className={"active-box"}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px",
                  }}
                >
                  <Typography
                    variant="h6"
                    fontWeight={700}
                    gutterBottom
                    sx={{
                      color: "white",
                    }}
                  >
                    {packToShow?.name}
                  </Typography>
                  <Box
                    sx={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      border: "2px solid white",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={onClose}
                  >
                    <img
                      src={crossMarkIcon}
                      style={{ color: "white", width: "12px", height: "12px" }}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: "10px",
                      backgroundColor: "transparent",
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        px: 1,
                        py: 0.3,
                        backgroundColor: "#F1F7FA24",
                        color: "#fff",
                        borderRadius: "20px",
                        fontWeight: 600,
                        display: "inline-block",
                        mb: 1,
                      }}
                    >
                      ${packToShow?.prices[0]?.unit_amount / 100} per month
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        px: 1,
                        py: 0.3,
                        backgroundColor: "#F1F7FA24",
                        color: "#fff",
                        borderRadius: "20px",
                        fontWeight: 600,
                        display: "inline-block",
                        mb: 1,
                      }}
                    >
                      ${packToShow?.prices[1]?.unit_amount / 100} per year
                    </Typography>
                  </Box>
                </Box>
                {packToShow?.introductoryOffer?.isActive && (
                  <Box
                    className={"time-offer-card sponsor-modal"}
                    sx={{
                      background:
                        "linear-gradient(to right, #FFF5D6, #FFD75D, #FFF5D6, #FFD75D)",
                      width: "calc(100% - 60px)",
                      position: "absolute",
                      left: 0,
                      right: 0,
                      top: "20%",
                      margin: "auto",
                      borderRadius: "10px",
                      padding: "13px",
                      marginBottom: "13px",
                      textAlign: "left",
                      height: "70px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "12px",
                          sm: "14px",
                          md: "14px",
                          lg: "14px",
                          xl: "16px",
                        },
                        fontWeight: 700,
                        color: "black",
                      }}
                    >
                      Limited Time Offer!
                    </Typography>
                    <Typography
                      variant="p"
                      sx={{
                        fontSize: {
                          xs: "12px",
                          sm: "13px",
                          md: "11px",
                          lg: "11px",
                          xl: "14px",
                        },
                      }}
                    >
                      Get {packToShow?.introductoryOffer?.freeMonths} extra
                      months of Free Content Retention!
                    </Typography>
                  </Box>
                )}
              </Box>
              <Box
                sx={{
                  padding: packToShow?.introductoryOffer?.isActive
                    ? "30px 15px 15px"
                    : "15px",
                  height: "calc(100vh - 180px)",
                  overflow: "auto",
                }}
              >
                <Typography
                  sx={{
                    fontSize: {
                      xs: "14px",
                      sm: "15px",
                      md: "15px",
                      lg: "15px",
                      xl: "16px",
                    },
                    fontWeight: 400,
                    lineHeight: {
                      xs: "21px",
                      sm: "24px",
                    },
                    color: "#000000B2",
                    textAlign: "left",
                    marginBottom: "17px",
                  }}
                >
                  Designed for organizations eager to explore the Echo platform,
                  our Essentials Plan is the perfect way to spotlight your
                  organization in a dynamic community of aviation professionals!
                  Whether you&apos;re looking to increase brand recognition or
                  engage with industry leaders and rising talent alike, this
                  plan opens the door to exciting opportunities that can elevate
                  your presence in the aviation industry.
                  <br />
                  <Typography
                    sx={{
                      color: "#2A4876",
                      marginTop: "10px",
                      fontWeight: "600",
                      fontSize: "18px",
                    }}
                  >
                    Our One-Year Essentials plan helps you amplify your presence
                    and engage with the aviation industry on a deeper level
                  </Typography>
                </Typography>

                <Typography
                  sx={{
                    color: "#2A4876",
                    fontWeight: "bold",
                    textAlign: "left",
                    fontSize: "15px",
                  }}
                >
                  Webinars & Virtual Events
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    marginTop: "5px",
                    gap: "5px",
                    marginBottom: "20px",
                  }}
                >
                  <img
                    src={greenTick}
                    alt="Green Tick"
                    style={{ width: "24px", height: "24px" }}
                  />
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "13px",
                      },
                      fontWeight: 400,
                      color: "#152134",
                      textAlign: "left",
                    }}
                  >
                    Host up to 2 webinars or virtual events per year to engage
                    with the aviation community.
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    color: "#2A4876",
                    fontWeight: "bold",
                    textAlign: "left",
                    fontSize: "15px",
                  }}
                >
                  Share Your Organization&apos;s Voice
                </Typography>
                {console.log(packToShow?.name)}
                <Box sx={{ marginBottom: "20px" }}>
                  {sponsorsModalList[packToShow?.name.toLowerCase()].map(
                    (item) => (
                      <Box
                        sx={{
                          display: "flex",
                          marginTop: "5px",
                          gap: "5px",
                        }}
                        key={item}
                      >
                        <img
                          src={greenTick}
                          alt="Green Tick"
                          style={{ width: "24px", height: "24px" }}
                        />
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "13px",
                            },
                            fontWeight: 400,
                            color: "#152134",
                            textAlign: "left",
                          }}
                        >
                          {item}
                        </Typography>
                      </Box>
                    ),
                  )}
                </Box>
                <Typography
                  sx={{
                    color: "#2A4876",
                    fontWeight: "bold",
                    textAlign: "left",
                    fontSize: "15px",
                  }}
                >
                  Choose the payment option best suited to you:
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    marginTop: "10px",
                    gap: "10px",
                  }}
                >
                  <img
                    src={flightIcon}
                    alt=""
                    style={{
                      width: "21px",
                      height: "21px",
                    }}
                  />
                  <Typography>
                    <span style={{ fontWeight: "bold" }}>
                      ${packToShow?.prices[0]?.unit_amount / 100}/month with a
                      one-year commitment
                    </span>{" "}
                    for ultimate flexibility.
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "10px",
                    gap: "10px",
                    marginBottom: "20px",
                  }}
                >
                  <img
                    src={flightIcon}
                    alt=""
                    style={{
                      width: "21px",
                      height: "21px",
                    }}
                  />
                  <Typography>
                    <span style={{ fontWeight: "bold" }}>
                      ${packToShow?.prices[1]?.unit_amount / 100}/year
                    </span>{" "}
                    for long term growth and savings.
                  </Typography>
                </Box>

                <Typography
                  sx={{
                    textAlign: "left",
                    color: "#000000B2",
                    fontStyle: "italic",
                    fontSize: "14px",
                  }}
                >
                  This is a one year plan with an option to make monthly
                  payments for a total of 12 months or pay a full annual price
                  that includes one free month.
                </Typography>
                <hr />
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: "10px",
                    fontWeight: "bold",
                  }}
                >
                  Note:
                </Typography>
                <Typography
                  sx={{
                    textAlign: "left",
                    color: "#000000B2",
                    fontStyle: "italic",
                    fontSize: "14px",
                  }}
                >
                  This offer extends the time your content is displayed,but it
                  does not allow for new content to be posted{" "}
                  <b>beyond your subscription period.</b>Content posting is only
                  available during the active subscription.
                </Typography>
              </Box>
            </Box>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default YearlyEssentialModal;
